import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import { FeatureEnum, GroupIdEnum } from 'app/modules/Segment/types';
import { OabCaptureSurface, OabSource } from 'app/services/tracking/oabCapture/oabCaptureEvents';

// confirmOab/setupOAB são chamadas por 7 telas diferentes (captura, onboarding,
// perfil, "Gerenciar minhas OABs" e as 3 variantes de setup do JusProcessos) —
// sem essa distinção, oab_confirmed não deixa isolar quantas confirmações vêm
// de cada fluxo, e um funil de captura que usasse oab_confirmed como fundo de
// funil misturaria confirmações que nada têm a ver com a captura.
export type OabConfirmationSurface =
  | OabCaptureSurface
  | 'onboarding'
  | 'account_profile'
  | 'oab_management'
  | 'lawsuits_monitor_setup'
  | 'lawsuits_monitor_setup_v2'
  | 'lawsuits_monitor_setup_steps';

const OAB_CONFIRMED_EVENT = 'oab_confirmed';

export function trackOabConfirmed(
  oabSource: OabSource,
  surface: OabConfirmationSurface,
): void {
  eventTracker.track({
    event: OAB_CONFIRMED_EVENT,
    properties: buildJusfyEventsProperties({
      event: OAB_CONFIRMED_EVENT,
      feature: FeatureEnum.JUS_PROCESSOS,
      eventMeaning:
        '[Captura OAB] A OAB do usuário foi confirmada com sucesso, disparando o monitoramento de processos — manualmente (setupOAB) ou a partir de uma OAB pendente já deduzida (confirmOab). oab_source distingue as duas origens; surface distingue a tela de onde a confirmação veio.',
      relevantUserActivity: true,
      extraProperties: { oab_source: oabSource, surface },
    }),
    context: buildJusfyEventsContext({
      groupId: GroupIdEnum.JUSPROCESSOS_GROUP,
      component: 'oab-confirmation-api',
    }),
  });
}
